'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _constants = require('./constants');

function init(accounts) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1';

    var callbackQueue = (0, _constants.callbackQueueName)(version);
    window[_constants.accountListName] = window[_constants.accountListName] || [];
    window[_constants.accountListName] = window[_constants.accountListName].concat(accounts);
    window[callbackQueue] = window[callbackQueue] || [];
    window[callbackQueue].push(function () {
        accounts.forEach(function (id) {
            var defaultOptions = { id: id };

            try {
                window[(0, _constants.trackerInstanceName)(id)] = new Ya[(0, _constants.trackerConstructorName)(version)](Object.assign(defaultOptions, options));
            } catch (ex) {
                console.warn(ex);
            }
        });
    });
    accounts.forEach(function (id) {
        window[(0, _constants.trackerVersionName)(id)] = version;
    });
} /* eslint-env browser */
/* global Ya */

;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-yandex-metrika/lib/init.js
// module id = 853
// module chunks = 0